const DOUBLE_ZERO = '00';
const PLUS = '+';

export const prefixPhoneNumberWith00 = ({ phoneNumber = '' }) => {
  if (!phoneNumber || phoneNumber.startsWith(DOUBLE_ZERO)) return phoneNumber;
  if (phoneNumber.startsWith(PLUS)) return `${DOUBLE_ZERO}${phoneNumber.slice(1)}`;
  return `${DOUBLE_ZERO}${phoneNumber}`;
};
